export const RECOMMENDED_RAIL_TYPES = ['fake_recommendation_id']

// Recommendation feature is disabled as delivery got postponed, when need to be enable add below array for above constant -
// [
//     'VODContent_movies_recommendation',
//     'VODContent_series_ltcu_recommendation_portrait',
//     'VODContent_series_ltcu_recommendation_landscape',
//     'VODContent_series_ltcu_recommendation_hybrid'
// ]

export enum PlayerOverlays {
    SYNOPSIS = 'SYNOPSIS',
    AUDIO_SUBTITLE = 'AUDIO_SUBTITLE',
    MINI_EPG = 'MINI_EPG',
    MATCH_STATS = 'MATCH_STATS',
    MULTICAM = 'MULTICAM',
    BINGE_WATCHING = 'BINGE_WATCHING', // This is for handling parental, we are not showing any overlay for this right now.
    RECORDING_POPUP = 'RECORDING_POPUP',
    PLAY_PAUSE_POPUP = 'PLAY_PAUSE_POPUP',
    NEXT_PROGRAM_POPUP = 'NEXT_PROGRAM_POPUP',
    PLAYER_ERROR_POPUP = 'PLAYER_ERROR_POPUP',
    PLAYER_EXIT_POPUP = 'PLAYER_EXIT_POPUP',
    SUBSCRIPTION_CHANNEL_POPUP = 'SUBSCRIPTION_CHANNEL_POPUP',
    SUBSCRIPTION_PACKAGE_POPUP = 'SUBSCRIPTION_PACKAGE_POPUP',
    THUMBNAIL_PREVIEW = 'THUMBNAIL_PREVIEW'
}

export enum RemoteKeyPressed {
    KEY_DOWN = "ArrowDown",
    KEY_UP = "ArrowUp",
    KEY_RIGHT = "ArrowRight",
    KEY_LEFT = "ArrorLeft",
    KEY_ENTER = "Enter",
    KEY_PLAY_PAUSE = "PlayPause",
    KEY_PLAY = "Play",
    KEY_PAUSE = "Pause",
    KEY_REWIND = "Rewind",
    KEY_FAST_FORWARD = "FastForward",
    KEY_STOP = "Stop"
}

export enum ADPOSITION {
    PRE_ROLL = 'Pre-roll',
    MID_ROLL = 'Mid-roll',
    POST_ROLL = 'Post-roll',
}

export enum ACCOUNT_DETAIL_FIELDS {
    ACCOUNT_ID = 'accountId',
    ACCOUNT_NUMBER = 'accountNumber',
    DEVICE_NAME = 'deviceName',
    DEVICE_MODEL = 'deviceModel',
    DEVICE_OS = "deviceOs",
    DEVICE_MANIFACTURER = "deviceManifacturer",
    UUID = 'uuidNumber',
    INTERNET_STATUS = 'internetStatus',
    CONNECTION_TYPE = 'connectionType',
    CONNECTION_QUALITY = 'connectionQuality',
    LAUNCHER_VERSION = 'apkVersion',
    POPULATION = 'population',
    BUSINESS_TYPE = 'businessType',
}